import { schemaMixin } from '@witkac/jschema';
import formComponents from '../components/formComponents';
let components = null;
// if (window && window.Vue) {
if ((typeof window !== "undefined") && (window.Vue)) {
  //są zarejestrowane globalnie
  components = null;

} else {
  components = formComponents;
}

function isComponent(component, className, tagName) {
  let Ctor = component.$vnode.componentOptions.Ctor;
  if ((Ctor) && (Ctor.extendOptions) && (Ctor.extendOptions.name === className)) {
    return true;
  } else {
    if (component.$vnode.componentOptions.tag === tagName) {
      return true;
    }
  }
  return false;

};

// import { fixSchemaDefaultOptions } from '../utils/JsonSchema';
// fixSchemaDefaultOptions.arrayItemGuidField = 'Guid';

export default {
  mixins: [schemaMixin],

  components: components,
  props: ['datamodel', 'external', 'confirmDelete', 'tabChange'],
  data() {
    let data = {};

    return {
      model: this.$props.datamodel,
      form: {
        fieldsChanged: [],
        pow: [],
        gmi: []
      }
    };
  },
  beforeMount() { },
  mounted() {
    if (this.$external.$settings && this.form.sections) {
      for (let index = 0; index < this.form.sections.length; index++) {
        const item = this.form.sections[index];

        item.unlockInfo = this.$external.$settings.unlockInfo;
        if (this.$external.$settings.tabsEnabled) {
          item.tabEnabled = this.$external.$settings.tabsEnabled.includes(index);
        }
        if (this.$external.$settings.tabsDisabled) {
          item.tabDisabled = this.$external.$settings.tabsDisabled.includes(index);
        }
      }
    }
  },
  methods: {
    prevStep(event) {
      const index = this.form.sections.findIndex(s => s.name == this.form.currentSection.name) - 1;
      if (index >= 0) {
        this.onChangeTab(event, this.form.sections[index]);
      }
    },
    nextStep(event) {
      const index = this.form.sections.findIndex(s => s.name == this.form.currentSection.name) + 1;
      if (index < this.form.sections.length) {
        this.onChangeTab(event, this.form.sections[index]);
      }
    },
    onChangeTab(event, section) {
      const errors = this.validateSection(this.form.currentSection);

      if (this.$listeners['before-change-tab']) {
        return new Promise((resolve, reject) => {
          this.$emit('before-change-tab', event, section, errors.length > 0, resolve);
        }).then(result => {
          if (result) {
            this.changeTab(section);
          }
        });
      } else {
        this.changeTab(section);
      }
    },
    changeTab(section) {
      this.form.currentSection = section;
      this.form.fieldsChanged = [];
      this.$emit('sectionchanged', section, this.form.sections);
    },

    allComponents(parentComponent, componentTag, result) {
      if (parentComponent.$vnode.componentOptions.tag === componentTag) {
        result.push(parentComponent);
        return result;
      }

      if (parentComponent.$children) {
        const l = parentComponent.$children.length;
        for (let i = 0; i < l; i++) {
          this.allComponents(parentComponent.$children[i], componentTag, result);
        }
      }
      return result;
    },
    validateSection(section) {
      const stime = new Date().getTime();
      const self = this;
      let ss = null;
      for (let i = 0; i < self.$children.length; i++) {
        const component = self.$children[i];
        if (isComponent(component, 'WSection', 'w-section')) {
          //if (component.$vnode.componentOptions.tag === 'w-section') {
          if (component.section === section) {
            ss = component;
            break;
          }
        }
      }
      if (ss === null) {
        return [];
      }

      const result = [];

      const traverseError = (parentComponent) => {
        if (isComponent(parentComponent, 'WError', 'w-error')) {
          const model = parentComponent.model;
          const vres = model.$validate();
          if (vres) {
            result.push(parentComponent);
          }

        }


        if (parentComponent.$children) {
          const l = parentComponent.$children.length;
          for (let i = 0; i < l; i++) {
            traverseError(parentComponent.$children[i]);
          }
        }
      };
      traverseError(ss);

      // console.log('validateSection', new Date().getTime() - stime, result.length, result[0]);
      // result[20].$emit('focus');
      return result;
    },
    resetSection(section) {
      const stime = new Date().getTime();
      const self = this;
      let ss = null;
      for (let i = 0; i < self.$children.length; i++) {
        const component = self.$children[i];
        // if (component.$vnode.componentOptions.tag === 'w-section') {
        if (component.section === section) {
          ss = component;
          break;
        }
        // }
      }
      if (ss === null) {
        return [];
      }

      const result = [];

      const traverseError = (parentComponent) => {
        if (isComponent(parentComponent, 'WError', 'w-error')) {
          const model = parentComponent.model;
          if (model.$error) {
            model.$reset();
            result.push(parentComponent);
          }
        }


        if (parentComponent.$children) {
          const l = parentComponent.$children.length;
          for (let i = 0; i < l; i++) {
            traverseError(parentComponent.$children[i]);
          }
        }
      };
      traverseError(ss);

      // console.log('validateSection', new Date().getTime() - stime, result.length, result[0]);
      // result[20].$emit('focus');
      return result;
    }
  },
  computed: {
    isLastSection: {
      get() {
        return this.form.sections[this.form.sections.length - 1].name == this.form.currentSection;
      }
    },

    isFirstSection: {
      get() {
        return this.form.sections[0].name == this.form.currentSection;
      }
    },
    disabledKonkursDates: {
      get() {
        if (this.$external.$konkurs.TerminOd && this.$external.$konkurs.TerminDo) {
          let toDate = new Date(this.$external.$konkurs.TerminOd);
          let fromDate = new Date(this.$external.$konkurs.TerminDo);

          fromDate.setHours(0);
          fromDate.setMinutes(0);
          fromDate.setSeconds(0);

          if (this.$external.$settings.maxDays && this.model.DataStart) {
            let tmp = new Date(this.model.DataStart);
            tmp.setHours(0);
            tmp.setMinutes(0);
            tmp.setSeconds(0);

            tmp.setDate(tmp.getDate() + this.$external.$settings.maxDays);
            if (tmp < fromDate) {
              fromDate = tmp;
            }
          }

          fromDate.setDate(fromDate.getDate() + 1);

          return {
            to: toDate,
            from: fromDate
          };
        }

        return undefined;
      }
    }
  },
  beforeCreate() {
    const props = this.$options.propsData;

    if (props.external) {
      this.$options.external = props.external;
      delete props.external;
    }
  },
  mounted() {
    if (window) {
      window.vm = this;
    }
  }
};
